import { render, staticRenderFns } from "./field-image-input.vue?vue&type=template&id=6f8cbe82&scoped=true&"
import script from "./field-image-input.vue?vue&type=script&lang=js&"
export * from "./field-image-input.vue?vue&type=script&lang=js&"
import style0 from "./field-image-input.vue?vue&type=style&index=0&id=6f8cbe82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8cbe82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VCard,VIcon,VImg,VMessages})
